import { useSyncExternalStore } from "react";

// Every banner the site shows is also kept here, so Notification Center can list it later.
let nextId = 1;
let items = [
  {
    id: nextId++,
    title: "Sylvester",
    body: "Hey, thanks for stopping by! My resume is in Notes. Double-click it on the desktop, or press ⌘K and search.",
    time: Date.now(),
  },
];
const listeners = new Set();

const emit = () => listeners.forEach((listener) => listener());

export const notifications = {
  add(body, title = "Sylvester") {
    items = [{ id: nextId++, title, body, time: Date.now() }, ...items];
    emit();
  },
  remove(id) {
    items = items.filter((item) => item.id !== id);
    emit();
  },
  clear() {
    items = [];
    emit();
  },
};

const subscribe = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

const useNotifications = () => useSyncExternalStore(subscribe, () => items);

export default useNotifications;

